(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('Alert', [
        '$rootScope', 
        '$sanitize', 
        '$translate', 
        'CorrelationService',
        AlertFn
    ]);

    /* main alert service */
    function AlertFn($rootScope, $sanitize, $translate, CorrelationService) {

        var defaultTimeOut = 5000;
        var defaultPositionClass = "toast-bottom-right";

        toastr.options = {
            closeDuration: 100,
            extendedTimeout: 10,
            timeOut: defaultTimeOut,
            positionClass: defaultPositionClass,
            preventDuplicates: true
        };

        $rootScope.$on('response-error', function(event, errorObj) {
            error(errorObj);
        });

        // define service
        var service = {
            translateSuccess: translateSuccess,
            success: success,
            error: error,
            danger: danger,
            warning: warning,
            info: info
        };

        return service;

        /* info message */
        function info(message) {
            if (angular.isArray(message)) {
                message = message[0];
            }

            // options set
            toastr.options.timeOut = 10000; // has to click
            toastr.options.closeButton = true;
            toastr.info($sanitize(message));
            
        }

        /* success message */
        function success(message) {
            if (angular.isArray(message)) {
                message = message[0];
            }
            toastr.options.positionClass = defaultPositionClass;
            toastr.options.timeOut = defaultTimeOut;

            toastr.success($sanitize(message));
        }
        
        function translateSuccess(key) {
            toastr.options.positionClass = defaultPositionClass;
            toastr.options.timeOut = defaultTimeOut;
            toastr.success($translate.instant(key));
        }

        /* warning message */
        function warning(message) {
            if (angular.isArray(message)) {
                message = message[0];
            }
            toastr.options.positionClass = defaultPositionClass;
            toastr.options.timeOut = defaultTimeOut;
            toastr.warning($sanitize(message));
        }

        /* danger/error message */
        function danger(message) {
            toastr.options.positionClass = defaultPositionClass;
            toastr.options.timeOut = defaultTimeOut;
            toastr.error($sanitize(message));
        }

        
        function error(errorObj) {
            toastr.options.positionClass = defaultPositionClass;
            toastr.options.timeOut = 10000;
            toastr.options.tapToDismiss = false;
            
            // Immediately remove current toasts without using animation
            toastr.remove();

            // Get the correlation ID
            const correlationId = (errorObj && errorObj.CorrelationId) ?
                errorObj.CorrelationId :
                null;

            // Create the correlation ID footer if available
            const correlationFooter = correlationId
                ? `<br/><strong>Correlation ID: </strong>${$sanitize(correlationId)}`
                : '';
            
            if (errorObj) {
                // check if the error is an untranslated error, 
                // then show the full (English) message 
                if (errorObj.title === 'legacy_error') {
                    toastr.error(errorObj.detail + correlationFooter);
                } else if (errorObj.type === 'ValidationFailure') {
                    // Show a toast for every FluentValidation error in the ValidationProblemDetails
                    errorObj.errors.errorMessages.forEach(errorMessage => {
                        toastr.error(errorMessage + correlationFooter, errorObj.title);
                    });

                    for (let i = 0; i < errorObj.errors.errorCodes.length; i += 2)
                    {
                        let errorCode = errorObj.errors.errorCodes[i];
                        let defaultErrorMessage = errorObj.errors.errorCodes[i + 1];
                        
                        let translatedErrorMessage = $translate.instant(errorCode);
                        if (translatedErrorMessage !== errorCode) {
                            toastr.error(translatedErrorMessage + correlationFooter, errorObj.title);
                            continue;
                        }
                        // translation failed, sending default error message
                        toastr.error(defaultErrorMessage + correlationFooter, errorObj.title);
                    }
                    
                    errorObj.errors.errorCodes.forEach(errorCode => {
                    });
                } else if (typeof errorObj === 'string') {
                    toastr.error($translate.instant(errorObj) +  correlationFooter);
                } else {   
                    // translate the error
                    toastr.error($translate.instant(errorObj.title) + correlationFooter);
                }
            } else {
                toastr.error($translate.instant('unhandled_error'));                
            }
        }
    }
})();